import React, { useEffect, useState } from 'react'
import i18n from 'live/services/i18n'

import moment from 'moment'

import { HeaderContainer, MainContainer, TitleContainer } from './headerStyles'
import { getServerLocalTimeZone } from '../../api/api'

export function ReportHeader(): JSX.Element {
    const [serverLocalTime, setServerLocalTime] = useState<string>()

    useEffect(() => {
        let intervalId

        getServerLocalTimeZone().then(res => {
            intervalId = setInterval(() => {
                const convertedDate = new Date().toLocaleString('en-US', { timeZone: res })
                setServerLocalTime(moment(convertedDate).format('LTS'))
            }, 1000)
        })

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    return (
        <HeaderContainer>
            <MainContainer>
                <TitleContainer>
                    <span>APPS</span>
                    <label>{i18n('Reports Approval')}</label>
                    {serverLocalTime && (
                        <label className="server-local-time">{i18n(`Server local time`) + serverLocalTime}</label>
                    )}
                </TitleContainer>
            </MainContainer>
        </HeaderContainer>
    )
}
